import { objectKeys, isNullish } from '@caresend/utils';

/* eslint-disable no-param-reassign */
/**
 * Inject nulls into an objects properties that are possibly undefined
 *
 * A suitable usecase is initializing a reactive object for optimized
 * vDOM updates.
 */
const injectNulls = (obj) => {
    const newObj = {};
    objectKeys(obj).forEach((key) => {
        if (obj[key] === undefined) {
            newObj[key] = null;
        }
        else {
            newObj[key] = obj[key];
        }
    });
    return newObj;
};
/**
 * Used to clean and object to set values of:
 * `undefined`, empty objects/arrays, empty
 * strings to `null` recursively.
 */
const injectNullsDeep = (obj, recursionBlockerKeys = [], level = 0) => {
    if (isNullish(obj))
        return null;
    if (obj !== null && typeof obj === 'object') {
        Object.keys(obj).forEach((k) => {
            const key = k;
            if (isNullish(obj[key])) {
                obj[key] = null;
            }
            else if (typeof obj[key] === 'string' && obj[key] === '') {
                obj[key] = null;
            }
            else if ((Array.isArray(obj[key]) && obj[key].length === 0)
                || (typeof obj[key] === 'object' && Object.keys(obj[key]).length === 0)) {
                obj[key] = null;
            }
            else if (recursionBlockerKeys.includes(key) && level < 2) {
                /** Prevent infinite recursive object size */
                obj[key] = null;
            }
            else {
                obj[key] = injectNullsDeep(obj[key], recursionBlockerKeys, level + 1);
            }
        });
    }
    return obj;
};

export { injectNulls, injectNullsDeep };
